<template>
  <div class="ViewReportsDataCollectionsLKList">
    <div class="ViewReportsDataCollectionsLKList__header">
      <h1 class="ViewReportsDataCollectionsLKList__title">
        Отчеты по сборам данных
      </h1>
    </div>

    <div class="ViewReportsDataCollectionsLKList__content">
      <v-simple-table class="ViewReportsDataCollectionsLKList__table">
        <template #default>
          <thead>
            <tr>
              <th class="text-left">
                Название отчета
              </th>
              <th class="text-right" style="width: 200px;" />
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="report in reports"
              :key="report.id"
            >
              <td>{{ report.title }}</td>
              <td class="text-right">
                <v-btn
                  color="primary"
                  outlined
                  :loading="loadingReportId === report.id"
                  :disabled="loadingReportId === report.id"
                  @click="onCreateReport(report)"
                >
                  Сформировать
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import { LKPublicationsFormdataReportModal } from '@/views/LKPublications/formdata/utils'
import { ReportsApi } from '@/api/resources/ReportsApi'
import { DATA_COLLECTIONS_REPORTS } from './reportsConfig'
import { getModalCreator } from './modalsRegistry'

const reportsApi = new ReportsApi()

export default {
  name: 'ViewReportsDataCollectionsLKList',
  data: () => ({
    reports: DATA_COLLECTIONS_REPORTS,
    loadingReportId: null,
  }),
  methods: {
    async onCreateReport(report) {
      try {
        // eslint-disable-next-line no-console
        console.log('onCreateReport called', report)
        // Получаем функцию создания модалки из реестра
        const modalCreator = getModalCreator(report.paramsModal)
        // eslint-disable-next-line no-console
        console.log('modalCreator:', modalCreator, 'paramsModal:', report.paramsModal)

        // Если есть модалка для выбора параметров - показываем её
        if (modalCreator) {
          const modal = await modalCreator(this, {
            on: {
              ready: (params) => this.onCreate(report, params),
            },
          })
          if (modal && modal.open) {
            await modal.open()
          }
        } else {
          // eslint-disable-next-line no-console
          console.log('No modal creator, creating report directly')
          // Иначе сразу создаем отчет без параметров
          await this.onCreate(report, {})
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error in onCreateReport:', error)
        this.$notice.error('Ошибка при открытии формы выбора параметров')
      }
    },

    async onCreate(report, params) {
      this.loadingReportId = report.id

      const payload = {
        code: report.code,
        params: params || {},
      }

      try {
        const propsData = {
          reportCode: report.reportCode,
          params: params || {},
          title: report.title,
        }
        const reportModal = await LKPublicationsFormdataReportModal(this, propsData)
        await reportModal.open()
      } catch (e) {
        this.$notice.error('Произошла ошибка при попытке сформировать отчет, обратитесь к администратору')
      } finally {
        this.loadingReportId = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ViewReportsDataCollectionsLKList {
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;

  &__header {
    margin-bottom: 24px;
  }

  &__title {
    font-size: 28px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }

  &__content {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }

  &__table {
    ::v-deep {
      thead th {
        font-weight: 600;
        font-size: 14px;
        background-color: #f5f5f5;
      }

      tbody td {
        font-size: 14px;
        padding: 16px;
      }
    }
  }
}
</style>


